import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useDataAggregation } from '../../Common/hooks/useAggregationData';
import { useCadUniqueChartsDataContext } from './hooks/useCadUniqueChartsDataContext';
import { getMonthLabel } from '../../../Common/Util/getMonthLabel'

export const PeopleMonth = () => {
    const { chartData } = useCadUniqueChartsDataContext();

    const rawData = chartData?.peopleMonth || [];

    const series = [
        {
            name: 'Pessoas Cadastradas',
            data: chartData?.peopleMonth?.map(item => item.value) || []
        }
    ];

    const isYearComparison = rawData.length > 0 && rawData.every(item => item.mes === rawData[0].mes);
    const formattedSubtitles = isYearComparison ? rawData.map(item => `${getMonthLabel(item.mes)}/${item.ano}`): rawData.map(item => getMonthLabel(item.mes));
    

    return (
        <SimpleBars
            title={'Evolução mensal das pessoas cadastradas'}
            horizontal={false}
            subtitles={formattedSubtitles}
            series={series}
            stacked
        />
    );
};